module.exports = __webpack_public_path__ + "static/media/sylvan.6bbe7676.png";